import LayoutsBase from './shared/layouts/Base';

import NavBar from './shared/NavBar';
import Footer from './shared/Footer';
import BestFriend from './shared/BestFriend';
import Login from './shared/Login';
import Weather from './shared/Weather';

import Welcome from './welcome/Welcome';
import Summary from './welcome/Summary';
import CustomizeYourStay from './welcome/CustomizeYourStay';
import CustomizeYourStayCard from './welcome/CustomizeYourStayCard';
import Cards from './welcome/Cards';

import ReachUsMapBanner from './reach_us/MapBanner';

import Events from './events/Events';
import EventsMapBanner from './events/MapBanner';
import CategoryExplorer from './events/CategoryExplorer';
import EventsCardsSlider from './events/EventsCardsSlider';
import AttractionsCardsSlider from './events/AttractionsCardsSlider';
import BwRewards from './events/BwRewards';

import Restaurants from './restaurants/Restaurants';
import Menu from './restaurants/Menu';
import MenuCard from './restaurants/MenuCard';
import VenuesCardsSlider from './restaurants/VenuesCardsSlider';

import Customize from './customize/Customize';
import ServiceCard from './customize/ServiceCard';
import ServiceModal from './customize/ServiceModal';

import MailUnsubscribe from './mail_unsubscribe/MailUnsubscribe';
import DuringStaySurvey from './during-stay-survey/DuringStaySurvey';

import News from './news/News';
import NewsCategoryExplorer from './news/NewsCategoryExplorer';
import NewsCardsSlider from './news/NewsCardsSlider';

export const en = {
    shared: {
        ...LayoutsBase.en.shared,
        ...NavBar.en.shared,
        ...Footer.en.shared,
        ...BestFriend.en.shared,
        ...Login.en.shared,
        ...Weather.en.shared
    },
    welcome: {
        ...Welcome.en.welcome,
        ...Cards.en.welcome,
        ...Summary.en.welcome,
        ...CustomizeYourStay.en.welcome,
        ...CustomizeYourStayCard.en.welcome
    },
    reach_us: {
        ...ReachUsMapBanner.en.reach_us
    },
    events: {
        ...Events.en.events,
        ...EventsMapBanner.en.events,
        ...CategoryExplorer.en.events,
        ...EventsCardsSlider.en.events,
        ...AttractionsCardsSlider.en.events,
        ...BwRewards.en.events
    },
    restaurants: {
        ...Restaurants.en.restaurants,
        ...Menu.en.restaurants,
        ...MenuCard.en.restaurants,
        ...VenuesCardsSlider.en.restaurants
    },
    customize: {
        ...Customize.en.customize,
        ...ServiceCard.en.customize,
        ...ServiceModal.en.customize
    },
    mail_unsubscribe: {
        ...MailUnsubscribe.en.mail_unsubscribe
    },
    news: {
        ...News.en.news,
        ...NewsCategoryExplorer.en.news,
        ...NewsCardsSlider.en.news,
    },
  duringStaySurvey: {
    ...DuringStaySurvey.en.duringStaySurvey
  }
};

export const de = {
    shared: {
        ...LayoutsBase.de.shared,
        ...NavBar.de.shared,
        ...Footer.de.shared,
        ...BestFriend.de.shared,
        ...Login.de.shared,
        ...Weather.de.shared
    },
    welcome: {
        ...Welcome.de.welcome,
        ...Cards.de.welcome,
        ...Summary.de.welcome,
        ...CustomizeYourStay.de.welcome,
        ...CustomizeYourStayCard.de.welcome
    },
    reach_us: {
        ...ReachUsMapBanner.de.reach_us
    },
    events: {
        ...Events.de.events,
        ...EventsMapBanner.de.events,
        ...CategoryExplorer.de.events,
        ...EventsCardsSlider.de.events,
        ...AttractionsCardsSlider.de.events,
        ...BwRewards.de.events
    },
    restaurants: {
        ...Restaurants.de.restaurants,
        ...Menu.de.restaurants,
        ...MenuCard.de.restaurants,
        ...VenuesCardsSlider.de.restaurants
    },
    customize: {
        ...Customize.de.customize,
        ...ServiceCard.de.customize,
        ...ServiceModal.de.customize
    },
    mail_unsubscribe: {
        ...MailUnsubscribe.de.mail_unsubscribe
    },
    news: {
        ...News.de.news,
        ...NewsCategoryExplorer.de.news,
        ...NewsCardsSlider.de.news,
    },
  duringStaySurvey: {
    ...DuringStaySurvey.de.duringStaySurvey
  }
};

export const es = {
    shared: {
        ...LayoutsBase.es.shared,
        ...NavBar.es.shared,
        ...Footer.es.shared,
        ...BestFriend.es.shared,
        ...Login.es.shared,
        ...Weather.es.shared
    },
    welcome: {
        ...Welcome.es.welcome,
        ...Cards.es.welcome,
        ...Summary.es.welcome,
        ...CustomizeYourStay.es.welcome,
        ...CustomizeYourStayCard.es.welcome
    },
    reach_us: {
        ...ReachUsMapBanner.es.reach_us
    },
    events: {
        ...Events.es.events,
        ...EventsMapBanner.es.events,
        ...CategoryExplorer.es.events,
        ...EventsCardsSlider.es.events,
        ...AttractionsCardsSlider.es.events,
        ...BwRewards.es.events
    },
    restaurants: {
        ...Restaurants.es.restaurants,
        ...Menu.es.restaurants,
        ...MenuCard.es.restaurants,
        ...VenuesCardsSlider.es.restaurants
    },
    customize: {
        ...Customize.es.customize,
        ...ServiceCard.es.customize,
        ...ServiceModal.es.customize
    },
    mail_unsubscribe: {
        ...MailUnsubscribe.es.mail_unsubscribe
    },
    news: {
        ...News.es.news,
        ...NewsCategoryExplorer.es.news,
        ...NewsCardsSlider.es.news,
    },
  duringStaySurvey: {
    ...DuringStaySurvey.es.duringStaySurvey
  }
};

export const fr = {
    shared: {
        ...LayoutsBase.fr.shared,
        ...NavBar.fr.shared,
        ...Footer.fr.shared,
        ...BestFriend.fr.shared,
        ...Login.fr.shared,
        ...Weather.fr.shared
    },
    welcome: {
        ...Welcome.fr.welcome,
        ...Cards.fr.welcome,
        ...Summary.fr.welcome,
        ...CustomizeYourStay.fr.welcome,
        ...CustomizeYourStayCard.fr.welcome
    },
    reach_us: {
        ...ReachUsMapBanner.fr.reach_us
    },
    events: {
        ...Events.fr.events,
        ...EventsMapBanner.fr.events,
        ...CategoryExplorer.fr.events,
        ...EventsCardsSlider.fr.events,
        ...AttractionsCardsSlider.fr.events,
        ...BwRewards.fr.events
    },
    restaurants: {
        ...Restaurants.fr.restaurants,
        ...Menu.fr.restaurants,
        ...MenuCard.fr.restaurants,
        ...VenuesCardsSlider.fr.restaurants
    },
    customize: {
        ...Customize.fr.customize,
        ...ServiceCard.fr.customize,
        ...ServiceModal.fr.customize
    },
    mail_unsubscribe: {
        ...MailUnsubscribe.fr.mail_unsubscribe
    },
    news: {
        ...News.fr.news,
        ...NewsCategoryExplorer.fr.news,
        ...NewsCardsSlider.fr.news,
    },
  duringStaySurvey: {
    ...DuringStaySurvey.fr.duringStaySurvey
  }
};

export const it = {
    shared: {
        ...LayoutsBase.it.shared,
        ...NavBar.it.shared,
        ...Footer.it.shared,
        ...BestFriend.it.shared,
        ...Login.it.shared,
        ...Weather.it.shared
    },
    welcome: {
        ...Welcome.it.welcome,
        ...Cards.it.welcome,
        ...Summary.it.welcome,
        ...CustomizeYourStay.it.welcome,
        ...CustomizeYourStayCard.it.welcome
    },
    reach_us: {
        ...ReachUsMapBanner.it.reach_us
    },
    events: {
        ...Events.it.events,
        ...EventsMapBanner.it.events,
        ...CategoryExplorer.it.events,
        ...EventsCardsSlider.it.events,
        ...AttractionsCardsSlider.it.events,
        ...BwRewards.it.events
    },
    restaurants: {
        ...Restaurants.it.restaurants,
        ...Menu.it.restaurants,
        ...MenuCard.it.restaurants,
        ...VenuesCardsSlider.it.restaurants
    },
    customize: {
        ...Customize.it.customize,
        ...ServiceCard.it.customize,
        ...ServiceModal.it.customize
    },
    mail_unsubscribe: {
        ...MailUnsubscribe.it.mail_unsubscribe
    },
    news: {
        ...News.it.news,
        ...NewsCategoryExplorer.it.news,
        ...NewsCardsSlider.it.news,
    },
  duringStaySurvey: {
    ...DuringStaySurvey.it.duringStaySurvey
  }
};



// WEBPACK FOOTER //
// ./translations/index.js